import { render, staticRenderFns } from "./CbsAiAssistant.vue?vue&type=template&id=0f5ff66c&scoped=true"
import script from "./CbsAiAssistant.vue?vue&type=script&lang=js"
export * from "./CbsAiAssistant.vue?vue&type=script&lang=js"
import style0 from "./CbsAiAssistant.vue?vue&type=style&index=0&id=0f5ff66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ff66c",
  null
  
)

export default component.exports